export default {
  titles: {
    pickup: 'Retrait',
    delivery: 'Livraison',
  },
  buttons: {
    confirm: 'Confirmer',
  },
};
